(function () {
  'use strict';

  const API_BASE_URL = 'https://license.voltyid.com/api/v1';
  const API_TOKEN = 'JSlOqvH66YKjy1mvGGHyqfUZXJ7hPM4VlpfjyuLCpv';
  const DISCOUNT_CODE = 'VoltyLife20';
  const stepLabels = ['Reason', 'Options', 'Confirm'];

  const cancelData = {
    email: '',
    activation_code: '',
    reason: '',
    cancel_time: '',
    subscription: null,
    locked: false,
    lockedMessage: ''
  };

  let currentStep = 'start';

  function qs(selector, scope = document) {
    return scope.querySelector(selector);
  }

  function qsa(selector, scope = document) {
    return Array.from(scope.querySelectorAll(selector));
  }

  function resetData() {
    cancelData.email = '';
    cancelData.activation_code = '';
    cancelData.reason = '';
    cancelData.cancel_time = '';
    cancelData.subscription = null;
    cancelData.locked = false;
    cancelData.lockedMessage = '';
  }

  function buildStepper() {
    const stepperEl = qs('#stepper');
    if (!stepperEl) return;

    stepperEl.innerHTML = '';

    stepLabels.forEach((label, index) => {
      const stepNum = index + 1;
      const step = document.createElement('div');
      step.className = 'step';
      step.dataset.step = String(stepNum);
      step.innerHTML = `
        <button type="button" aria-label="Go to step ${stepNum}">
          <span class="dot">
            <p class="f--13px lh--loosev mf--11px f--bold-500 m-0">Step ${stepNum}</p>
          </span>
          <span class="label">
            <p class="f--16px lh--loosev f--bold-500 mf--14px">${label}</p>
          </span>
        </button>
      `;

      qs('button', step).addEventListener('click', () => handleStepClick(stepNum));
      stepperEl.appendChild(step);
    });
  }

  function goToStep(step) {
    currentStep = step;

    qsa('[data-step]').forEach(el => el.classList.remove('is-active'));

    const target = qs(`[data-step="${step}"]`);
    if (target) target.classList.add('is-active');

    const stepperWrap = qs('#stepperWrap');
    const shouldShowStepper = ['reason', 'options', 'confirm', 'success'].includes(step);

    if (stepperWrap) {
      stepperWrap.classList.toggle('hidden', !shouldShowStepper);
      stepperWrap.classList.toggle('visible', shouldShowStepper);
    }

    updateStepper(step);
  }

  function updateStepper(step) {
    const map = { reason: 1, options: 2, confirm: 3, success: 3 };
    const active = map[step];

    qsa('.stepper .step').forEach(el => {
      const num = Number(el.dataset.step);
      const locked = cancelData.locked && num < 3;

      el.classList.toggle('active', num === active);
      el.classList.toggle('completed', Boolean(active) && num < active && !locked);
      el.classList.toggle('is-locked', locked);

      const button = qs('button', el);
      if (button) button.disabled = locked;
    });
  }

  function handleStepClick(stepNum) {
    const map = { 1: 'reason', 2: 'options' };

    if (cancelData.locked && stepNum < 3) {
      showNotice(cancelData.lockedMessage || 'This subscription cannot be changed.');
      return;
    }

    if (stepNum === 3) {
      if (currentStep === 'success' || cancelData.locked) {
        goToStep('success');
        return;
      }

      showNotice('Confirm cancellation first', qs('.cancel-options') || document);
      return;
    }

    if (stepNum === 2 && !cancelData.reason) {
      showNotice('Select a reason first');
      return;
    }

    goToStep(map[stepNum]);
  }

  async function apiRequest(endpoint, payload) {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      // headers: {
      //   Authorization: `Bearer ${API_TOKEN}`,
      //   'Content-Type': 'application/json',
      //   Accept: 'application/json'
      // },
      body: JSON.stringify(payload)
    });

    let body = null;

    try {
      body = await response.json();
    } catch (error) {
      body = null;
    }

    if (body?.status === 'success') {
      return body;
    }

    const error = new Error(body?.message || body?.error || 'Request failed');
    error.responseBody = body;
    error.httpStatus = response.status;
    throw error;
  }

  function basePayload(extra = {}) {
    return {
      license: cancelData.activation_code,
      email: cancelData.email,
      ...extra
    };
  }

  function showFieldError(name, message) {
    const input = qs(`[name="${name}"]`);
    const errorEl = qs(`[data-error="${name}"]`);

    if (input) input.classList.add('input-error');
    if (errorEl) errorEl.textContent = message;
  }

  function clearFieldError(name) {
    const input = qs(`[name="${name}"]`);
    const errorEl = qs(`[data-error="${name}"]`);

    if (input) input.classList.remove('input-error');
    if (errorEl) errorEl.textContent = '';
  }

  function createNotice(scope = document) {
    const notice = document.createElement('p');
    notice.className = 'form-error js-api-message';
    notice.setAttribute('role', 'alert');
    notice.style.marginTop = '12px';
    notice.style.textAlign = 'center';

    const anchor =
      qs('.submit-btn, .confirm-btn, .next-btn, .options-offer-card-2, .confirm-retention', scope) ||
      qs('.submit-btn');

    if (anchor?.parentElement) anchor.parentElement.appendChild(notice);

    return notice;
  }

  function showNotice(message, scope = document) {
    const host = qs('.js-api-message', scope) || qs('.js-api-message') || createNotice(scope);
    host.textContent = message || '';
    host.hidden = !message;
  }

  function setLoading(button, isLoading, label) {
    if (!button) return;

    const textEl = qs('span', button) || button;

    if (!button.dataset.originalText) {
      button.dataset.originalText = textEl.textContent.trim();
    }

    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
    textEl.textContent = isLoading ? label : button.dataset.originalText;
  }

  function formatDate(dateValue) {
    if (!dateValue) return '';

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return dateValue;

    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  function fallbackResumeDate() {
    const date = new Date();
    date.setMonth(date.getMonth() + 1);
    return date.toISOString().slice(0, 10);
  }

  function getSubscription() {
    return cancelData.subscription?.subscription || cancelData.subscription || {};
  }

  function getSubscriptionStatus() {

    const subscription = getSubscription();
    const actions = getAvailableActions();

    const canCancelNow =
      actions.cancel_now === true;

    const canCancelAtRenewal =
      actions.cancel_at_renewal === true;

    const canPause =
      actions.pause === true;

    const canResume =
      actions.resume === true;

    const canApplyDiscount =
      actions.apply_discount === true;

    /*
      CANCELLED LOGIC
    */

    const isCancelled =
      !canCancelNow &&
      !canCancelAtRenewal;

    /*
      PAUSED LOGIC
      Security check:
      resume must exist
    */

    const isPaused =
      canResume === true &&
      !canPause;

    return {
      subscription,
      actions,

      isCancelled,
      isPaused,

      canPause,
      canResume,
      canApplyDiscount
    };

  }

  function getAvailableActions() {
    const actions = cancelData.subscription?.available_actions;
    return actions && !Array.isArray(actions) ? actions : {};
  }

  function setActionVisibility() {

    const {
      canPause,
      canApplyDiscount
    } = getSubscriptionStatus();

    /*
      PAUSE BUTTON
    */

    qsa('.js-pause-btn').forEach(btn => {
      btn.hidden = !canPause;
      btn.disabled = !canPause;
    });

    /*
      DISCOUNT BUTTON
    */

    qsa('.js-discount-btn').forEach(btn => {
      btn.hidden = !canApplyDiscount;
      btn.disabled = !canApplyDiscount;
    });

  }

  function resetActionVisibility() {
    qsa('.js-pause-btn, .js-discount-btn').forEach(btn => {
      btn.hidden = false;
      btn.disabled = false;
    });

    qsa('input[name="cancel_time"]').forEach(input => {
      input.disabled = false;
      const row = input.closest('.form-group');
      if (row) row.hidden = false;
    });

    qsa('.cancel-options .confirm-btn').forEach(btn => {
      btn.disabled = false;
    });
  }

  function updateRenewDateLabels() {
    const renewDate = getSubscriptionStatus().subscription.renew_date;
    const label = renewDate ? `(${formatDate(renewDate)})` : '(end of current period)';

    qsa('.js-renew-date').forEach(el => {
      el.textContent = label;
    });
  }

  function updateSuccess(title, message, effectiveDate, options = {}) {
    const titleEl = qs('.js-success-title');
    const messageEl = qs('.js-success-message');
    const dateWrap = qs('.js-effective-date-wrap');
    const dateStrong = dateWrap ? qs('strong', dateWrap) : null;
    const reactivateBtn = qs('.js-reactivate-btn');

    if (titleEl) titleEl.textContent = title;
    if (messageEl) messageEl.textContent = message;

    if (dateWrap) {
      dateWrap.hidden = !effectiveDate;
      if (dateStrong) dateStrong.textContent = formatDate(effectiveDate);
    }

    if (reactivateBtn) reactivateBtn.hidden = !options.showReactivate;
  }

  function lockToConfirm(title, message, showReactivate = false) {
    cancelData.locked = true;
    cancelData.lockedMessage = message;
    updateSuccess(title, message, null, { showReactivate });
    goToStep('success');
  }

  function applySubscriptionResult(result) {

    cancelData.subscription = result.data;

    cancelData.locked = false;
    cancelData.lockedMessage = '';

    updateRenewDateLabels();
    setActionVisibility();

    const {
      isPaused,
      isCancelled
    } = getSubscriptionStatus();

    /*
      CANCELLED
    */

    if (isCancelled) {

      cancelData.locked = true;

      lockToConfirm(
        'Subscription Already Cancelled',
        'This subscription is already cancelled.',
        false
      );

      return false;
    }

    /*
      PAUSED
    */

    if (isPaused) {

      cancelData.locked = true;

      lockToConfirm(
        'Subscription Is Paused',
        'Your subscription is paused. You can reactivate it anytime.',
        true
      );

      return false;
    }

    return true;

  }

  function resetFormUi() {
    const startForm = qs('#startForm');
    const reasonSelect = qs('.reason-select');
    const reasonNext = qs('.cancel-reason .next-btn');

    if (startForm) startForm.reset();
    if (reasonSelect) reasonSelect.selectedIndex = 0;
    if (reasonNext) reasonNext.disabled = true;

    qsa('input[name="cancel_time"]').forEach(radio => {
      radio.checked = false;
    });

    clearFieldError('email');
    clearFieldError('activation_code');
    showNotice('');
    resetActionVisibility();
    updateRenewDateLabels();
    updateSuccess(
      'Your Subscription Has Been Cancelled',
      'If you change your mind, you can easily reactivate your subscription at any time.',
      null,
      { showReactivate: false }
    );
  }

  function bindStartForm() {
    const startForm = qs('#startForm');
    if (!startForm || startForm.dataset.voltyBound === 'true') return;

    startForm.dataset.voltyBound = 'true';

    qsa('input', startForm).forEach(input => {
      input.addEventListener('input', () => clearFieldError(input.name));
    });

    startForm.addEventListener('submit', async function (e) {
      e.preventDefault();

      const email = this.email.value.trim();
      const code = this.activation_code.value.trim();
      const submitBtn = qs('.submit-btn', this);
      clearFieldError('email');
      clearFieldError('activation_code');
      showNotice('', startForm);

      resetData();
      cancelData.email = email;
      cancelData.activation_code = code;

      try {
        setLoading(submitBtn, true, 'Searching...');
        console.log('Volty subscription search request started');
        const result = await apiRequest('/subscription-search', basePayload());
        const canContinue = applySubscriptionResult(result);

        if (canContinue) goToStep('reason');
      } catch (error) {
        const message = error.responseBody?.message || error.message || 'Request failed';
        showFieldError('email', '');
        showFieldError('activation_code', '');
        showNotice(message, startForm);
      } finally {
        setLoading(submitBtn, false);
      }
    });
  }

  function bindReasonStep() {
    const reasonSelect = qs('.reason-select');
    const reasonNext = qs('.cancel-reason .next-btn');

    if (!reasonSelect || !reasonNext || reasonSelect.dataset.voltyBound === 'true') return;

    reasonSelect.dataset.voltyBound = 'true';

    reasonSelect.addEventListener('change', () => {
      cancelData.reason = reasonSelect.value;
      reasonNext.disabled = !cancelData.reason;
    });

    reasonNext.addEventListener('click', () => {
      if (!cancelData.reason) return;
      goToStep('options');
    });
  }

  async function performCancellation(button, scope) {
    if (!cancelData.cancel_time) {
      showNotice('Select cancellation timing', scope);
      return;
    }

    const endpoint =
      cancelData.cancel_time === 'immediate'
        ? '/subscription-cancel-now'
        : '/subscription-cancel-renewal';

    try {
      setLoading(button, true, 'Cancelling...');
      const result = await apiRequest(endpoint, basePayload({ reason: cancelData.reason }));
      const effectiveDate =
        result.data?.cancelled_at ||
        result.data?.scheduled_cancellation_date ||
        result.data?.active_until ||
        getSubscriptionStatus().subscription.renew_date;

      updateSuccess(
        'Your Subscription Has Been Cancelled',
        result.message || 'Your subscription cancellation has been confirmed.',
        effectiveDate,
        { showReactivate: false }
      );
      goToStep('success');
    } catch (error) {
      showNotice(error.responseBody?.message || error.message || 'Request failed', scope);
    } finally {
      setLoading(button, false);
    }
  }

  function bindCancelOptions() {
    qsa('input[name="cancel_time"]').forEach(radio => {
      if (radio.dataset.voltyBound === 'true') return;

      radio.dataset.voltyBound = 'true';
      radio.addEventListener('change', () => {
        cancelData.cancel_time = radio.value;

        qsa(`input[name="cancel_time"][value="${radio.value}"]`).forEach(matchingRadio => {
          matchingRadio.checked = true;
        });
      });
    });

    qsa('.cancel-options .confirm-btn').forEach(btn => {

      if (btn.dataset.voltyBound === 'true') return;

      btn.dataset.voltyBound = 'true';

      btn.addEventListener('click', async () => {

        const checkedRadio = qs('input[name="cancel_time"]:checked');

        if (!checkedRadio) {
          showNotice('Select cancellation timing', qs('.cancel-options'));
          return;
        }

        cancelData.cancel_time = checkedRadio.value;

        await performCancellation(btn, qs('.cancel-options'));

      });

    });
  }

  function bindRetentionActions() {
    qsa('.js-pause-btn').forEach(btn => {
      if (btn.dataset.voltyBound === 'true') return;

      btn.dataset.voltyBound = 'true';
      btn.addEventListener('click', async () => {
        if (!cancelData.email || !cancelData.activation_code) {
          showNotice('Submit your email and license key first.');
          goToStep('start');
          return;
        }

        if (!window.confirm('Do you want to pause the subscription?')) return;

        const resumeDate = getSubscriptionStatus().subscription.renew_date || fallbackResumeDate();

        try {
          setLoading(btn, true, 'Pausing...');
          const result = await apiRequest('/subscription-pause', basePayload({ resume_date: resumeDate }));
          updateSuccess(
            'Your Subscription Has Been Paused',
            result.message || 'Your subscription has been paused.',
            result.data?.resume_date || resumeDate,
            { showReactivate: true }
          );
          cancelData.locked = true;
          cancelData.lockedMessage = 'Your subscription has been paused.';
          goToStep('success');
        } catch (error) {
          showNotice(error.message, btn.closest('section') || document);
        } finally {
          setLoading(btn, false);
        }
      });
    });

    qsa('.js-discount-btn').forEach(btn => {
      if (btn.dataset.voltyBound === 'true') return;

      btn.dataset.voltyBound = 'true';
      btn.addEventListener('click', async () => {
        if (!cancelData.email || !cancelData.activation_code) {
          showNotice('Submit your email and license key first.');
          goToStep('start');
          return;
        }

        try {
          setLoading(btn, true, 'Applying...');
          const result = await apiRequest(
            '/subscription-discount',
            basePayload({ discount_code: DISCOUNT_CODE })
          );
          updateSuccess(
            'Your 20% Discount Has Been Applied',
            result.message || 'Your lifetime discount has been applied successfully.',
            result.data?.applied_at,
            { showReactivate: false }
          );
          goToStep('success');
        } catch (error) {
          showNotice(error.message, btn.closest('section') || document);
        } finally {
          setLoading(btn, false);
        }
      });
    });

    const reactivateBtn = qs('.js-reactivate-btn');
    if (!reactivateBtn || reactivateBtn.dataset.voltyBound === 'true') return;

    reactivateBtn.dataset.voltyBound = 'true';
    reactivateBtn.addEventListener('click', async () => {
      if (!cancelData.email || !cancelData.activation_code) {
        showNotice('Submit your email and license key first.');
        goToStep('start');
        return;
      }

      try {
        setLoading(reactivateBtn, true, 'Reactivating...');
        const result = await apiRequest('/subscription-resume', basePayload());
        updateSuccess(
          'Your Subscription Has Been Reactivated',
          result.message || 'Your subscription has been resumed successfully.',
          result.data?.resumed_at,
          { showReactivate: false }
        );
        cancelData.locked = false;
        cancelData.lockedMessage = '';
        updateStepper('success');
      } catch (error) {
        showNotice(error.message, qs('.cancel-success'));
      } finally {
        setLoading(reactivateBtn, false);
      }
    });
  }

  function init() {
    resetData();
    buildStepper();
    resetFormUi();
    bindStartForm();
    bindReasonStep();
    bindCancelOptions();
    bindRetentionActions();
    goToStep('start');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
